import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { ViewerSessionsDropmenu } from '@components/viewer-sessions';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import { CONST_STATE } from '@store/viewerSessions/reducer';
import commonSelector from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';

// migrated from old dimenesion container
// TODO: cleanup
function ViewerControls() {
  const viewerDrillDownKey = 'trends';

  const customerAccountType = get(useSelector(commonSelector), [
    'features',
    featureNames.CUSTOMER_ACCOUNT_TYPE,
  ]);

  const { selectedMetrics, anchoredMetrics, exceedTimeLimit } = get(
    useSelector(viewerSessionsSelector),
    [viewerDrillDownKey],
    CONST_STATE,
  );

  return (
    <ViewerSessionsDropmenu
      selectedMetrics={selectedMetrics}
      anchoredMetrics={anchoredMetrics}
      exceedTimeLimit={exceedTimeLimit}
      viewerDrillDownKey={viewerDrillDownKey}
      customerAccountType={customerAccountType}
    />
  );
}

export default ViewerControls;
